import angular from 'angular';

let contacts = angular
    .module('contacts', ['contactsAppTemplates']);

export default contacts; 